export enum ProjectTypes {
  GEO_BASIC = 'geo_basic',
  GEO_BASIC_WIDGET = 'geo_basic_widget',
  GEO_ADVANCED = 'geo_advanced',
  GEO_ADVANCED_WIDGET = 'geo_advanced_widget'
}
